export const initModvideo = () => {
  document.addEventListener('click', onDocClick);
};

const onDocClick = (e: MouseEvent) => {
  const link = (e.target as Element).closest<HTMLAnchorElement>('a.video-trigger');
  if (!link) return;
  e.preventDefault();

  const url = link.dataset.url;
  const selector = link.dataset.selector;
  const wrapper = selector ? document.querySelector(selector) : null;

  if (!url || !wrapper || link.classList.contains('loading')) return;

  link.classList.add('loading');

  fetch(url)
    .then((r) => r.text())
    .then((html) => {
      wrapper.innerHTML = html;
    })
    .catch(() => {
      link.classList.remove('loading');
    });
};
